import React, {useEffect} from "react";
import {connect} from "react-redux";
import {bindActionCreators} from "redux";
import {RootState} from "../../store/store";
import {getExpenses} from "store/actions/Expenses";
import WaitingDots from "components/WaitingDots";
import {ExpenseState} from 'store/reducers/Expenses';
import ExpenseRowAccount from "./ExpenseRowAccount";
import {GetRouterQuery} from "components/Utils/GetRouterQuery";

interface Props { expenseState: ExpenseState; accountId: string | null; }
interface Actions { getExpenses: () => void; }

const ExpensesListAccount: React.FC<Props & Actions> = ({getExpenses, expenseState, accountId}) => {
    const {id} = GetRouterQuery<{ id: string }>();
    useEffect(() => { getExpenses(); }, [getExpenses]);
    if (!accountId) return <WaitingDots />;

    return <table className="table table table-borderless align-middle table-centered table mb-0"><tbody>
        {expenseState.getExpensesByAccountId(accountId)
            .sort((a, b) => b.GetDate().getTime() - a.GetDate().getTime())
            .map(expense => <ExpenseRowAccount key={expense.id} expense={expense} expenseId={id} />)}
    </tbody></table>;
};

const mapStateToProps = (state: RootState) => ({expenseState: state.Expenses});
const mapDispatchToProps = (dispatch: any) => bindActionCreators({getExpenses}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(ExpensesListAccount);
